<template>
  <div class="container-fluid py-3">

    <!-- ===== STICKY HEADER ===== -->
    <div class="uw-page-header mb-3">
      <div class="uw-header-left">
        <span class="uw-header-icon">
          <i class="bi bi-shield-check"></i>
        </span>
        <div>
          <h5 class="mb-0 fw-bold uw-title">Underwriting — Sığorta təklifi</h5>
          <small class="text-muted" style="font-size: 0.76rem;">Risklərin qiymətləndirilməsi və müqavilə təsdiqi</small>
        </div>
      </div>
      <div v-if="!editing && !insert" class="uw-header-actions">
        <button type="button" class="btn action-btn action-btn--excel" @click="approveDialog = true">
          <i class="bi bi-check2-square me-1"></i>
          <span>Təsdiq et</span>
        </button>
        <button type="button" class="btn action-btn action-btn--danger" @click="Delete()">
          <i class="bi bi-x-circle me-1"></i>
          <span>İmtina</span>
        </button>
        <button type="button" class="btn action-btn action-btn--muted" @click="GetData()">
          <i class="bi bi-arrow-clockwise me-1"></i>
          <span>Yeniləmək</span>
        </button>
      </div>
    </div>

    <!-- ===== CONTENT SECTIONS ===== -->
    <div v-loading="loading" class="uw-sections-wrapper">
      <Info class="mb-3"></Info>
      <Insured class="mb-3"></Insured>
      <Conditions class="mb-3"></Conditions>
      <Exceptions class="mb-3"></Exceptions>
      <Files class="mb-3"></Files>
    </div>

    <!-- ===== APPROVE DIALOG ===== -->
    <el-dialog
      v-model="approveDialog"
      width="440px"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      class="uw-approve-dialog"
    >
      <template #header>
        <div class="uw-dialog-header">
          <span class="uw-dialog-icon">
            <i class="bi bi-file-earmark-check-fill"></i>
          </span>
          <div>
            <div class="fw-bold" style="font-size: 0.95rem;">Müqavilə təsdiqi</div>
            <small class="text-muted" style="font-size: 0.75rem;">Yeni sığorta müqaviləsi yaradılacaq</small>
          </div>
        </div>
      </template>

      <div class="uw-dialog-body">
        <div class="uw-dialog-info-box mb-3">
          <i class="bi bi-info-circle me-2 text-info"></i>
          Müqavilə başlanma tarixi seçin. Sığorta dövrü bu tarixdən hesablanacaq.
        </div>
        <label class="uw-form-label">Müqavilə başlanma tarixi</label>
        <el-date-picker
          v-model="startDate"
          format="DD.MM.YYYY"
          class="w-100"
          type="date"
          placeholder="Tarixi seçin"
          size="large"
        />
      </div>

      <template #footer>
        <div class="uw-dialog-footer">
          <button class="btn action-btn action-btn--muted" @click="approveDialog = false">
            <i class="bi bi-x-lg me-1"></i>İmtina
          </button>
          <button class="btn action-btn action-btn--excel" @click="Approve()">
            <i class="bi bi-check2-square me-1"></i>Daxil et
          </button>
        </div>
      </template>
    </el-dialog>

  </div>
</template>

<script>
import Info from './Components/Info/Main.vue'
import Conditions from './Components/Conditions/Main.vue'
import Exceptions from './Components/Exceptions/Main.vue'
import Insured from './Components/Insured/Main.vue'
import Files from './Components/Files/Main.vue'

export default {
  name: "UnderwritingMain",
  components: {
    Info,
    Files,
    Exceptions,
    Insured,
    Conditions
  },
  data() {
    return {
      loading: false,
      editing: false,
      insert: false,
      startDate: null,
      approveDialog: false,
    }
  },
  mounted() {
    if (this.$route.path.split("/")[3] != null) {
      this.insert = false;
    }
  },
  methods: {
    Approve() {
      window.location.href = window.location.origin + '/documents/policy/' + 3;
    },
    GetData() {
      // refresh
    },
    Delete() {
      // decline
    }
  }
};
</script>

<style scoped lang="scss">
// ---- Page Header ----
.uw-page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  background: var(--app-surface, #ffffff);
  border: 1px solid var(--app-border, #e2e8f0);
  border-radius: var(--app-radius, 10px);
  padding: 14px 20px;
  position: sticky;
  top: 70px;
  z-index: 50;
  box-shadow: 0 1px 4px rgba(0,0,0,0.06);
}

.uw-header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.uw-header-icon {
  width: 38px;
  height: 38px;
  border-radius: 10px;
  background: rgba(16, 185, 129, 0.12);
  color: #059669;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
  flex-shrink: 0;
}

.uw-title {
  font-size: 0.95rem;
  color: var(--app-heading, #1e293b);
}

.uw-header-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

// ---- Approve Dialog ----
.uw-dialog-header {
  display: flex;
  align-items: center;
  gap: 12px;
}

.uw-dialog-icon {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: rgba(16, 185, 129, 0.12);
  color: #059669;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 1.1rem;
  flex-shrink: 0;
}

.uw-dialog-body {
  padding: 4px 0 8px;
}

.uw-dialog-info-box {
  background: rgba(14, 165, 233, 0.08);
  border: 1px solid rgba(14, 165, 233, 0.2);
  border-radius: 8px;
  padding: 10px 14px;
  font-size: 0.82rem;
  color: var(--app-text, #475569);
  line-height: 1.5;
}

.uw-form-label {
  display: block;
  font-size: 0.81rem;
  font-weight: 600;
  color: var(--app-text, #64748b);
  margin-bottom: 6px;
}

.uw-dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

// ---- Dark Mode ----
[data-theme="dark"] {
  .uw-page-header {
    background: #182029;
    border-color: #283544;
    box-shadow: 0 1px 4px rgba(0,0,0,0.35);
  }
  .uw-title { color: #f1f5f9; }
  .uw-dialog-info-box {
    background: rgba(14, 165, 233, 0.12);
    border-color: rgba(14, 165, 233, 0.3);
    color: #94a3b8;
  }
}
</style>